import React from "react";
import "../../App.css";
import ContactForm from "../ContactCard";
import Footer from "../Footer";
import Header from "../Header";

export default function Contact() {
  return (
    <>
      <Header />
      <ContactForm />
      <Footer />
    </>
  );
}
